import { browserHistory } from "react-router";
import { createItem } from "actions/item";
import rootStore from "reducers";
import GA from "lib/ga";
import { FBPixel } from "lib/fb";
import { isIframe, LS } from "../helpers/ApplicationHelper";
import { getSessionData } from "./personalize";
import { getItemsCount } from "../actions/itemsCount";

export const NEW_ITEM_PENDING = Symbol("NEW_ITEM_PENDING");
export const CREATE_ITEM_PENDING = Symbol("CREATE_ITEM_PENDING");
export const UPDATE_REFERRER = Symbol("UPDATE_REFERRER");

export const LAST_SUBMIT_LS_KEY = "lastSubmit";

export function newPendingItem(params, itemParams, isLoggedIn, itemDetails) {
    // createPendingItem
    itemParams.submitted_from = isIframe() ? "widget" : "app";
    itemParams.submit_second_item = localStorage.getItem("createSecondItem");
    itemParams.sessionData = getSessionData();
    itemParams.input_props = itemDetails;
    itemParams.userAgent = global.useragent;
    LS.set(LAST_SUBMIT_LS_KEY, itemDetails);

    rootStore.dispatch(createItem(itemParams)).then((res) => {
        let item = res.payload.data.item;

        GA.itemSubmissionSuccessfully();

        FBPixel.itemSubmitted(item.bundle.id, item.item_type_name);
        localStorage.removeItem("createSecondItem");

        if (isLoggedIn) {
            let user = res.payload.data.user;
            GA.itemSubmissionSuccessfully();
            if (itemParams.submitted_from === "widget") {
                //true if app is rendered as an iframe.
                window.top.location.href =
                    window.location.origin + "/item/" + item.id;
            } else {
                browserHistory.push("/item/" + item.id);
            }
            rootStore.dispatch(getItemsCount(user.id));
        }
    });

    return {
        payload: isLoggedIn
            ? null
            : Object.assign(
                  {},
                  { params },
                  { item: itemParams },
                  { referrer: "submissionForm" }
              ),
        type: isLoggedIn ? CREATE_ITEM_PENDING : NEW_ITEM_PENDING,
    };
}

export function updateReferrer(referrer) {
    return {
        type: UPDATE_REFERRER,
        payload: { referrer },
    };
}
